import React from "react";
import { Modal, Row, Col, Form, Button, Select, notification } from "antd";
import { compose } from "recompose";
import { withApollo } from "react-apollo";
import { withGlobal } from "../../../../component-global";
import { CustomRow } from "../../../../components/Grid";
import { SelectWithBorderComponent } from "../../../../components/FormFields";
import { AGENCY_SELECT_DROPDOWN_CLASS } from "../../AffiliatesAgency/components/style";
import { updateStatusAffiliates } from "../../../../graphQl/mutations/affiliate";

const { Option } = Select;

class ModalComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingButtonsModal: false,
      disableButtonsModal: true,
      stateSelected: null,
    };
  }

  updateStateInput = value => {
    this.setState({
      stateSelected: value,
      disableButtonsModal: !value,
    });
  };

  saveData = () => {
    const { stateSelected } = this.state;
    const { affiliatesIDsSelected, loadTable } = this.props;
    this.setState({
      loadingButtonsModal: true,
    });
    const variables = {
      userIDs: affiliatesIDsSelected,
      statusID: parseInt(stateSelected, 10),
    };

    this.props.client
      .mutate({
        mutation: updateStatusAffiliates,
        update: (cache, { data: { updateStatusAffiliates: response } }) => {
          response.statusCode === 200
            ? notification.success({ message: response.message })
            : notification.error({ message: response.message });
          this.props.onHandleCancelModal();
          loadTable();
        },
        variables,
      })
      .catch(() => {
        this.setState({ loadingButtonsModal: false });
        notification.error({
          message: "Hubo un error al actualizar los datos.",
        });
      });
  };

  render = () => {
    const { getFieldDecorator } = this.props.form;
    const {
      statusAffiliates,
      visible,
      onHandleCancelModal,
      wrapClassName,
    } = this.props;
    const {
      loadingButtonsModal,
      disableButtonsModal,
      stateSelected,
    } = this.state;

    const authEditDrawer = this.props.permissionsView
      ? this.props.permissionsView.edit
      : false;

    const renderStatusAffiliates = (statusAffiliates || []).map(obj => (
      <Option key={obj.subtype} value={obj.subtype}>
        {obj.subclass}
      </Option>
    ));

    return (
      <Modal
        title={null}
        visible={visible}
        footer={null}
        onCancel={onHandleCancelModal}
        width="400px"
        wrapClassName={wrapClassName}
        bodyStyle={{ height: "220px", fontFamily: "Gilroy, sans-serif" }}
      >
        <div style={{ textAlign: "center" }}>
          <p
            style={{
              fontFamily: "Gilroy, sans-serif",
              fontWeight: "bold",
              fontSize: "24px",
              lineHeight: "32px",
              textAlign: "center",
              color: "#595959",
              marginBottom: 20,
            }}
          >
            Cambiar estado afiliados
          </p>
        </div>
        <Row gutter={16} style={{ marginBottom: 15 }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <SelectWithBorderComponent
              style={{ width: "100%" }}
              getFieldDecorator={getFieldDecorator}
              title="Estado"
              decodator="statusID"
              value={stateSelected}
              options={renderStatusAffiliates}
              onChange={e => this.updateStateInput(e)}
              placeholder="Selecciones el estado"
              dropdownClassName={AGENCY_SELECT_DROPDOWN_CLASS}
            />
          </Col>
        </Row>

        <CustomRow gutter={24} type="flex" justify="space-around">
          <Col xs={{ span: 24 }} sm={{ span: 12 }} xl={{ span: 12 }}>
            <Button
              type="primary"
              ghost
              style={{
                width: "100%",
                fontFamily: "Gilroy, sans-serif",
                fontWeight: "600",
                fontSize: "14px",
                height: "40px",
              }}
              onClick={onHandleCancelModal}
              loading={loadingButtonsModal}
            >
              Cancelar
            </Button>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 12 }} xl={{ span: 12 }}>
            <Button
              type="primary"
              style={{
                width: "100%",
                fontFamily: "Gilroy, sans-serif",
                fontWeight: "600",
                fontSize: "14px",
                height: "40px",
              }}
              onClick={this.saveData}
              disabled={disableButtonsModal || authEditDrawer === false}
              loading={loadingButtonsModal}
            >
              Actualizar
            </Button>
          </Col>
        </CustomRow>
      </Modal>
    );
  };
}

const WraperModalAffiliate = withGlobal(ModalComponent);
const NewModalWarehouseForm = Form.create()(WraperModalAffiliate);

export default compose(withApollo)(NewModalWarehouseForm);
